import { render, staticRenderFns } from "./ticketSendTotal.vue?vue&type=template&id=25910dc4&"
import script from "./ticketSendTotal.vue?vue&type=script&lang=js&"
export * from "./ticketSendTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25910dc4')) {
      api.createRecord('25910dc4', component.options)
    } else {
      api.reload('25910dc4', component.options)
    }
    module.hot.accept("./ticketSendTotal.vue?vue&type=template&id=25910dc4&", function () {
      api.rerender('25910dc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/oilActivityManage/activityData/ticketSendTotal.vue"
export default component.exports